import { FC, ReactNode, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';
import { styled } from '@mui/material';
import { PopperProps } from '@mui/material/Popper';

export const SplitButton: FC<ISplitButton> = ({
  title,
  onClick,
  disabled,
  placement = 'bottom-end',
  children,
  mainButtonDataAttr,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <SWrapper>
      <ButtonGroup variant='contained' aria-label='split button'>
        <Button
          onClick={onClick}
          disabled={disabled}
          {...(mainButtonDataAttr && { 'data-attr': mainButtonDataAttr })}
        >
          {title}
        </Button>
        <Button
          size='small'
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label='select merge strategy'
          aria-haspopup='menu'
          disabled={disabled}
          onClick={handleToggle}
          ref={anchorRef}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        {...{ placement }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id='split-button-menu' autoFocusItem>
                  {children}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </SWrapper>
  );
};

const SWrapper = styled('div')(() => ({}));

interface ISplitButton {
  title: string;
  onClick: () => void;
  children?: ReactNode;
  disabled?: boolean;
  placement?: PopperProps['placement'];
  mainButtonDataAttr?: string;
}
